<div class="modal modal__opened" [class.modal_size_488]="requestInProgress" [class.modal_size_744]="!requestInProgress">
  <ng-container *ngIf="!requestInProgress else loader">
    <ng-container *ngIf="!subscriptionCompleted else subscriptionRequestSent">
      <div class="modal__close icon icon-close" (click)="close()"></div>
      <div class="modal__container">
        <div class="modal__img">
          <div class="modal-img modal-img_name_gift modal-img_size_192"></div>
        </div>
        <div class="modal__title modal__title-mb12 h2" *ngIf="!privetPlus">{{ 'activate-subscription-modal.title-privet' | translate }}</div>
        <div class="modal__title modal__title-mb12 h2" *ngIf="privetPlus">{{ 'activate-subscription-modal.title-privet-plus' | translate }}</div>
        <div class="modal__text" *ngIf="!privetPlus">{{ 'activate-subscription-modal.text-privet-new' | translate }}</div>
        <div class="modal__text" *ngIf="privetPlus">{{ 'activate-subscription-modal.text-privet-plus-new' | translate }}</div>
      </div>
      <div class="modal__buttons-row modal__buttons-mt40">
        <div class="button button_with_price" *ngIf="!privetPlus && !subscriptionActive" [innerHtml]="'activate-subscription-modal.connect-privet' | translate"
             (click)="subscribe()"></div>
        <div class="button button_with_price" *ngIf="privetPlus && !subscriptionActive" [innerHtml]="'activate-subscription-modal.connect-privet-plus' | translate"
             (click)="subscribe()"></div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #loader>
  <div class="modal__container modal__container-center">
    <div class="modal__loader with-icon"></div>
  </div>
</ng-template>

<ng-template #subscriptionRequestSent>
  <ng-container *ngIf="!wrongServiceError else wrongService">
    <div class="modal__close icon icon-close" (click)="close()"></div>
    <div class="modal__container">
      <div class="modal__img">
        <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
      </div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="!privetPlus">{{ 'activate-subscription-modal.connecting-privet' | translate }}</div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="privetPlus">{{ 'activate-subscription-modal.connecting-privet-plus' | translate }}</div>
      <div class="modal__text">{{ 'activate-subscription-modal.connecting-text' | translate }}</div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="close()">{{ 'activate-subscription-modal.ok-button' | translate }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #wrongService>
  <div class="modal__img">
    <div class="modal-img modal-img_name_whistling modal-img_size_192"></div>
  </div>
  <div class="modal__title modal__title-mb12 h2">{{ 'activate-subscription-modal.error' | translate }}</div>
  <div class="modal__text">{{ 'activate-subscription-modal.corp-subscriber' | translate }}</div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button button_type_light" (click)="close()">{{ 'activate-subscription-modal.ok-button' | translate }}</div>
  </div>
</ng-template>
